import Properties
    from "../../../../ApplicationBuilder/ApplicationDesigner/Designers/SchemaDesigner/SchemaProperties/Properties";
import PropTypes from "prop-types";
import {useSelector} from "react-redux";
import findByString from "../../../../../Utils/Form/FormDynamic/Utils/getValueByString";
import JsonScreenHoc from "../../../../../HocHelpers/JsonScreenHoc";

const FieldPropertiesComponent = (props) => {
    const {component: {styles: sourceStyles, properties}, values: propValues, screenName, collapsible} = props;
    const styles = sourceStyles?.length ? sourceStyles[0] : {};
    const globalValues = useSelector(state => state.jsonScreen.globalValues)
    const values = propValues ? propValues : findByString(globalValues.param[screenName], properties.dataSource)

    function onChange(v,p) {
        props.setValue(v, `${properties.dataSource}.${p}`)
    }

    return (
        <div style={{
            width: styles.width ? styles.width : '100%',
            height: styles.height ? styles.height : '100%'
        }}>
            <Properties
                selectedPath={" "}
                setValue={() => {}}
                onChangeSelectedProps={onChange}
                selectedField={{
                    field: values || {}
                }}
                styles={{
                    padding: styles.padding
                }}
                collapsible={collapsible}
            />
        </div>
    )
}

export default JsonScreenHoc(FieldPropertiesComponent);

FieldPropertiesComponent.propTypes = {
    component: PropTypes.shape({
        properties: PropTypes.shape({
            dataSource: PropTypes.string
        }).isRequired,
        styles: PropTypes.array.isRequired,
    }).isRequired,
    setValue: PropTypes.func,
}